import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=22a764bc&scoped=true"
import script from "./CategoryItem.vue?vue&type=script&lang=js"
export * from "./CategoryItem.vue?vue&type=script&lang=js"
import style0 from "./CategoryItem.vue?vue&type=style&index=0&id=22a764bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a764bc",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F01-atoms%2Fcategory-item%2FCategoryItem.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports